export const TERMS_CATEGORIES = ['terms_of_service', 'privacy_policy', 'feed_guidelines', 'marketing_consent', 'refund_exchange_policy']

// feed_guidelines가 없는 브랜드(Bettie, Pocapan)가 공유하는 탭 목록
export const TERMS_CATEGORIES_NO_FEED = ['terms_of_service', 'privacy_policy', 'marketing_consent', 'refund_exchange_policy']

/** @deprecated TERMS_CATEGORIES_NO_FEED 사용 */
export const TERMS_CATEGORIES_BETTIE = TERMS_CATEGORIES_NO_FEED

export const CONTENTFUL_CONTENT_TYPE_TERMS = 'terms'
export const CONTENTFUL_CONTENT_TYPE_TERMS_BETTIE = 'bettieTerms'
export const CONTENTFUL_CONTENT_TYPE_TERMS_POCAPAN = 'pocapanTerms'